import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./employment.module.scss";
import { withRouter } from "react-router-dom";
import { storeEmploymentDetails, saveApplication } from "../../redux/actions";
import {
  Warning,
  RadioSelector,
  Button,
  CheckboxSelector,
  ErrorMsg,
  DateWrapper
} from "@onegovbugs/onegov-react-components";
import Create from "@material-ui/icons/Create";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ScrollToTop from "../../utils/scrollToTop";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";

import {
  isAustralianPhoneNumberOrNull,
  isCompleted,
  isDateValidAndPast,
  isAFutureDate,
  validate,
  scrollToError
} from "../../utils/Validation";
import moment from "moment";

const Employment = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const form = useSelector(state => state.form);
  const employment = useSelector(state => state.employment);

  const [showErrors, setShowErrors] = useState(false);
  const [showErrorsMain, setShowErrorsMain] = useState(false);

  const [employmentFlag, setEmploymentFlag] = useState(
    employment ? employment.employmentFlag : ''
  );
  const [employerName, setEmployerName] = useState(
    ''
  );
  const [employerMobileNumber, setEmployerMobileNumber] = useState(
    ''
  );

  const [dayOfCommenced, setDayOfCommenced] = useState(
    ""
  );
  const [monthOfCommenced, setMonthOfCommenced] = useState(
    ""
  );
  const [yearOfCommenced, setYearOfCommenced] = useState(
    ""
  );

  const [dayOfFinished, setDayOfFinished] = useState(
    ""
  );
  const [monthOfFinished, setMonthOfFinished] = useState(
    ""
  );
  const [yearOfFinished, setYearOfFinished] = useState(
    ""
  );
  const [position, setPosition] = useState(
    ""
  );
  const [currentEmployment, setCurrentEmployment] = useState(
    []
  );

  const [viewMode, setViewMode] = useState(
    "list"
  );

  const [saveMode, setSaveMode] = useState(
    "add"
  );

  const [editRecordNumber, setEditRecordNumber] = useState(
    null
  );
  const [isCommencedValid, setIsCommencedValid] = useState(
    true
  );

  const [isFinishedValid, setIsFinishedValid] = useState(
    true
  );
  const [isCommencedDateRequired, setIsCommencedDateRequired] = useState(
    true
  );
  const [isFinishedDateRequired, setIsFinishedDateRequired] = useState(
    true
  );

  const [employmentHistory, setEmploymentHistory] = useState(employment && employment.employmentHistory ?
    employment.employmentHistory.map(on => ({ ...on })) :
    []);

  const radioOptionsYesNo = [
    {
      value: "yes",
      label: "Yes"
    },
    {
      value: "no",
      label: "No"
    }
  ];
  const defaultCheckboxValue = {
    value: 1,
    label: "Current"
  };

  const checkboxValues = [defaultCheckboxValue];

  useEffect(
    () => {
      validate(validators, setErrors);
    },
    [
      employerName,
      employerMobileNumber,
      dayOfCommenced,
      monthOfCommenced,
      yearOfCommenced,
      dayOfFinished,
      monthOfFinished,
      yearOfFinished,
      position,
      currentEmployment
    ]
  );

  useEffect(
    () => {
      validate(validatorsMain, setErrorsMain);
    },
    [
      employmentFlag,
      employmentHistory
    ]
  );

  const storeData = () => {
    dispatch(
      storeEmploymentDetails({
        employmentFlag,
        employmentHistory
      })
    );
  };

  const [errors, setErrors] = useState({
    employerName: false,
    employerMobileNumber: false,
    dateCommenced: false,
    dateFinished: false,
    position: false,
    duplicateEmployment: false
  });

  const [errorsMain, setErrorsMain] = useState({
    employmentFlag: false,
    employmentHistory: false
  });

  const validators = [
    {
      fieldName: "employerName",
      fieldValue: employerName,
      isValid: isCompleted
    },
    {
      fieldName: "dateCommenced",
      fieldValue: {
        day: dayOfCommenced,
        month: monthOfCommenced,
        year: yearOfCommenced
      },
      isValid: v => isCommencedDateRequired == false && isCommencedValid && isAFutureDate(dayOfCommenced, monthOfCommenced, yearOfCommenced) == false
    },
    {
      fieldName: "dateFinished",
      fieldValue: {
        day: dayOfFinished,
        month: monthOfFinished,
        year: yearOfFinished
      },
      isValid: v => currentEmployment == 1 || (isFinishedDateRequired == false && isFinishedValid && isAFutureDate(dayOfFinished, monthOfFinished, yearOfFinished) == false && isPastThanDateFinished() == true)
    },
    {
      fieldName: "employerMobileNumber",
      fieldValue: employerMobileNumber,
      isValid: v => isCompleted(v) && isAustralianPhoneNumberOrNull(v)
    },
    {
      fieldName: "position",
      fieldValue: position,
      isValid: isCompleted
    },
    {
      fieldName: "duplicateEmployment",
      fieldValue: employmentHistory,
      isValid: (v) => {
        let flagValid = false;
        let flagDuplicate = false;
        if (!errors.employerName && !errors.dateCommenced && !errors.dateFinished && !errors.employerMobileNumber && !errors.position) {
          v.map((el, index) => {

            if (el.name.toLowerCase() == employerName.toLowerCase()
              && el.dayOfCommenced.toLowerCase() == dayOfCommenced.toLowerCase()
              && el.monthOfCommenced.toLowerCase() == monthOfCommenced.toLowerCase()
              && el.yearOfCommenced.toLowerCase() == yearOfCommenced.toLowerCase()
              && el.dayOfFinished.toLowerCase() == dayOfFinished.toLowerCase()
              && el.monthOfFinished.toLowerCase() == monthOfFinished.toLowerCase()
              && el.yearOfFinished.toLowerCase() == yearOfFinished.toLowerCase()
              && el.phoneNumber.toLowerCase() == employerMobileNumber.toLowerCase()
              && el.position.toLowerCase() == position.toLowerCase()
              && el.currentEmployment.length == currentEmployment.length
              && (saveMode != "edit" || (saveMode == "edit" && index != editRecordNumber))
            ) {
              flagDuplicate = true;
            }

          });
        }
        if (flagDuplicate == false) {
          flagValid = true;
        } else {
          flagValid = false;
        }
        return flagValid;
      }
    }
  ];

  const validatorsMain = [
    {
      fieldName: "employmentFlag",
      fieldValue: employmentFlag,
      isValid: v => isCompleted(v)
    },
    {
      fieldName: "employmentHistory",
      fieldValue: employmentHistory,
      isValid: v => (employmentFlag == "no" || employmentHistory.length > 0)
    }
  ];
  const saveEmployerData = () => {
    if (saveMode == "add") {
      setEmploymentHistory([
        ...employmentHistory,
        {
          name: employerName,
          phoneNumber: employerMobileNumber,
          dayOfCommenced: dayOfCommenced,
          monthOfCommenced: monthOfCommenced,
          yearOfCommenced: yearOfCommenced,
          dayOfFinished: dayOfFinished,
          monthOfFinished: monthOfFinished,
          yearOfFinished: yearOfFinished,
          position: position,
          currentEmployment: currentEmployment
        }
      ]);
    }
    if (saveMode == "edit") {
      employmentHistory[editRecordNumber].name = employerName;
      employmentHistory[editRecordNumber].phoneNumber = employerMobileNumber;
      employmentHistory[editRecordNumber].dayOfCommenced = dayOfCommenced;
      employmentHistory[editRecordNumber].monthOfCommenced = monthOfCommenced;
      employmentHistory[editRecordNumber].yearOfCommenced = yearOfCommenced;
      employmentHistory[editRecordNumber].dayOfFinished = dayOfFinished;
      employmentHistory[editRecordNumber].monthOfFinished = monthOfFinished;
      employmentHistory[editRecordNumber].yearOfFinished = yearOfFinished;
      employmentHistory[editRecordNumber].position = position;
      employmentHistory[editRecordNumber].currentEmployment = currentEmployment;

      setEmploymentHistory(employmentHistory);
    }
    setSaveMode("");
    setEditRecordNumber(null);
  };

  const isPastThanDateFinished = () => {
    console.log('finished date', moment(`${yearOfFinished}-${monthOfFinished}-${dayOfFinished}`))
    console.log('commenced date', moment(`${yearOfCommenced}-${monthOfCommenced}-${dayOfCommenced}`))
    if (yearOfFinished < 1900)
      return false;
    if (currentEmployment == 1 || moment(`${yearOfFinished}-${monthOfFinished}-${dayOfFinished}`).isAfter(moment(`${yearOfCommenced}-${monthOfCommenced}-${dayOfCommenced}`)) == true) {
      return true;
    }
    else {
      return false;
    }
  }

  const isFutureDate = () => {
    if (moment().isAfter(moment(`${yearOfCommenced}-${monthOfCommenced}-${dayOfCommenced}`)) == true) {
      return true;
    }
    else {
      return false;
    }
  }


  const removeEmployerData = i => {
    let values = [...employmentHistory];
    values.splice(i, 1);
    setEmploymentHistory([...values]);
  };

  const clearForm = () => {
    setEmployerName("");
    setEmployerMobileNumber("");
    setDayOfCommenced("");
    setMonthOfCommenced("");
    setYearOfCommenced("");
    setDayOfFinished("");
    setMonthOfFinished("");
    setYearOfFinished("");
    setPosition("");
    setCurrentEmployment([]);
    window.setTimeout(() => {
      setErrors({
        employerName: false,
        employerMobileNumber: false,
        dateCommenced: false,
        dateFinished: false,
        position: false,
        duplicateEmployment: false
      })
    }, 1000);
  }
  const renderEmploymentHistory = () => {
    return (<div>
      <div className={styles.employmentHistoryTable}>
        <div className={styles.tableHeading + " " + styles.tableRow}>
          <div className={styles.tableColumn}>Name</div>
          <div className={styles.tableColumn}>Phone Number</div>
          <div className={styles.tableColumn}>Date Commenced</div>
          <div className={styles.tableColumn}>Date Finished</div>
          <div className={styles.tableColumn}>Position</div>
        </div>

        {employmentHistory.map((el, i) => (
          <div key={"employment-" + i} className={styles.tableRow}>
            <div className={styles.tableColumn}>{el.name}</div>
            <div className={styles.tableColumn}>{el.phoneNumber}</div>
            <div className={styles.tableColumn}>{el.dayOfCommenced + "/" + el.monthOfCommenced + "/" + el.yearOfCommenced}</div>
            <div className={styles.tableColumn}>{el.currentEmployment == 1 ? 'Current Employment' : el.dayOfFinished + "/" + el.monthOfFinished + "/" + el.yearOfFinished}</div>
            <div className={styles.tableColumn}>{el.position}</div>
            <div className={styles.tableColumn + " " + styles.actionColumn}>
              <Create onClick={() => { actionEdit(i); }} />
              <DeleteOutline onClick={() => { removeEmployerData(i); }} />
            </div>
          </div>
        ))}

      </div>
      {
        employmentHistory.length == 0 && (
          <div key={"employment-0"} className={styles.tableRowNodata}>
            <div className={styles.tableColumn}>No employment details added</div>
          </div>
        )
      }
    </div>
    );
  };

  const actionEdit = (itemNumber) => {
    setEditRecordNumber(itemNumber);
    setSaveMode("edit");
    setViewMode("form");
    setEmployerName(employmentHistory[itemNumber].name);
    setEmployerMobileNumber(employmentHistory[itemNumber].phoneNumber);
    setPosition(employmentHistory[itemNumber].position);
    setCurrentEmployment(employmentHistory[itemNumber].currentEmployment);
    setDayOfCommenced(employmentHistory[itemNumber].dayOfCommenced);
    setMonthOfCommenced(employmentHistory[itemNumber].monthOfCommenced);
    setYearOfCommenced(employmentHistory[itemNumber].yearOfCommenced);
    setDayOfFinished(employmentHistory[itemNumber].dayOfFinished);
    setMonthOfFinished(employmentHistory[itemNumber].monthOfFinished);
    setYearOfFinished(employmentHistory[itemNumber].yearOfFinished);
  }

  const renderEmploymentForm = () => {
    return (
      <div className={styles.employmentForm}>
        <div className={"row"}>
          <div className={"col-12"}>
            <h2>Add Employer</h2>
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="inputEmployerName" className={styles.smallParagraph}>
              Name
            </label>
            <input
              id="inputEmployerName"
              className={`${styles.inputBox}`}
              placeholder={"Name"}
              value={employerName}
              onChange={event => {
                setEmployerName(event.target.value);
              }}
            />
            {errors.employerName && showErrors ? (
              <ErrorMsg className={"ErrorMsg_error"}
                type={"error"}
                description={"Employer name is required."}
              />
            ) : null}
          </div>

          <div className={"col-12 col-sm-6"}>
            <label
              htmlFor="inputEmployerMobileNumber"
              className={styles.smallParagraph}
            >
              Mobile number
            </label>
            <input
              id="inputEmployerMobileNumber"
              className={`${styles.inputBox}`}
              placeholder={"Mobile number"}
              value={employerMobileNumber}
              onChange={event => {
                setEmployerMobileNumber(event.target.value);
              }}
            />

            {(employerMobileNumber == null || employerMobileNumber == "") && errors.employerMobileNumber && showErrors ? (
              <ErrorMsg className={"ErrorMsg_error"}
                type={"error"}
                description={"Mobile number is required."}
              />
            ) : null}
            {employerMobileNumber !== null && employerMobileNumber !== "" && errors.employerMobileNumber && showErrors ? (
              <ErrorMsg className={"ErrorMsg_error"}
                type={"error"}
                description={"Mobile number is invalid."}
              />
            ) : null}
          </div>
        </div>
        <div className={"row " + styles.topMargin24}>
          <div className={"col-12 col-sm-6"}>
            <div className={"row"}>
              <div className={"col-12"}>
                <label htmlFor="inputStartDate">Date Commenced</label>
                <p>
                  <small>For example 08 12 1990</small>
                </p>
              </div>
              <div id="inputStartDate" className={"col-12"}>
                <div className={"clearfix"}>
                  <DateWrapper
                    setDayOfBirth={setDayOfCommenced}
                    setMonthOfBirth={setMonthOfCommenced}
                    setYearOfBirth={setYearOfCommenced}
                    onValidationChange={setIsCommencedValid}
                    onValidationRequired={setIsCommencedDateRequired}
                    day={dayOfCommenced}
                    month={monthOfCommenced}
                    year={yearOfCommenced}
                    autotab
                  ></DateWrapper>
                </div>
                {showErrors ? (
                  isCommencedDateRequired ? (
                    <ErrorMsg className={"ErrorMsg_error"}
                      type={"error"}
                      description={"Date commenced is required."}
                    />
                  ) : (isCommencedValid == false ? (
                    <ErrorMsg className={"ErrorMsg_error"}
                      type={"error"}
                      description={"Date commenced is invalid."}
                    />
                  ) : (isAFutureDate(dayOfCommenced, monthOfCommenced, yearOfCommenced) == true ?
                    (<ErrorMsg
                      type={"error"}
                      description={"Date commenced cannot be in the future."}
                    />) : null))
                ) : null}
              </div>
            </div>
          </div>

          <div className={"col-12 col-sm-6"}>
            <div className={"row"}>
              <div className={"col-12"}>
                <label htmlFor="inputFinishedDate">Date Finished</label>
                <p>
                  <small>For example 08 12 1990</small>

                </p>
              </div>

              <div id="inputFinishedDate" className={"col-12 " + (currentEmployment == 1 ? styles.disableDate : '')}>
                <div className={"clearfix"}>

                  <DateWrapper
                    setDayOfBirth={setDayOfFinished}
                    setMonthOfBirth={setMonthOfFinished}
                    setYearOfBirth={setYearOfFinished}
                    onValidationChange={setIsFinishedValid}
                    onValidationRequired={setIsFinishedDateRequired}
                    day={dayOfFinished}
                    month={monthOfFinished}
                    year={yearOfFinished}
                    autotab
                  ></DateWrapper>
                </div>

                {currentEmployment != 1 && showErrors ? (
                  isFinishedDateRequired ? (
                    <ErrorMsg className={"ErrorMsg_error"}
                      type={"error"}
                      description={"Date finished is required."}
                    />
                  ) : (isFinishedValid == false ? (
                    <ErrorMsg className={"ErrorMsg_error"}
                      type={"error"}
                      description={"Date finished is invalid."}
                    />
                  ) : (isAFutureDate(dayOfFinished, monthOfFinished, yearOfFinished) == true ?
                    (<ErrorMsg
                      type={"error"}
                      description={"Date finished cannot be in the future."}
                    />) : (errors.dateCommenced == false && isPastThanDateFinished() == false ? (
                      <ErrorMsg
                        type={"error"}
                        description={"Date finished must be later than date commenced."}
                      />
                    ) : null)))
                ) : null}

              </div>

              <div className={styles.currentEmploymentRow}>
                <CheckboxSelector
                  onSelectionChange={v => {
                    setCurrentEmployment(v);
                    setDayOfFinished("");
                    setMonthOfFinished("");
                    setYearOfFinished("");
                    setIsFinishedDateRequired(!isFinishedDateRequired)
                  }
                  }
                  initialValue={currentEmployment}
                  options={checkboxValues}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={"row " + styles.topMargin24}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="inputPosition" className={styles.smallParagraph}>
              Position
            </label>
            <input
              id="inputPosition"
              className={`${styles.inputBox}`}
              placeholder={"Position"}
              value={position}
              maxLength="20"
              onChange={event => {
                setPosition(event.target.value);
              }}
            />
            {errors.position && showErrors ? (
              <ErrorMsg className={"ErrorMsg_error"} type={"error"} description={"Position is required."} />
            ) : null}
          </div>
        </div>

        {errors.duplicateEmployment && showErrors ? (
          <div className={"row " + styles.topMargin64}>
            <div className={"col-12"}>
              <ErrorMsg className={"ErrorMsg_error"} type={"error"} description={"Employment record is already used."} />
            </div>
          </div>
        ) : null}

        <div className={"row " + styles.topMargin128}>
          <div className={"col-12"}>
            <Button
              onClick={() => {

                if (validate(validators, setErrors)) {
                  saveEmployerData();
                  setViewMode("list");
                  clearForm();
                } else {
                  setShowErrors(true);
                  scrollToError();
                }
              }}
            >
              Save
            </Button>
            <Button secondary onClick={() => {
              setSaveMode("");
              setViewMode("list");
              clearForm();
              setShowErrors(false);
            }}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    );
  };
  const renderSection = () => {
    return (
      <div className={styles.section}>
        {viewMode == "list" && (
          <>
            <div className={"row"}>
              <div className={"col-12"}>
                <p>
                  You are required to provide evidence concerning previous, existing
                  or impending employment as a body art tattooist (including
                  employment as an apprentice).
                </p>                
              </div>
            </div>
            <div className={"row"}>
              <div className={"col-12"}>
                <label className={styles.anotherNameLabel}>
                  Do you have any previous, existing or impending employment as a body art tattooist?
            </label>
                <div className={styles.topMargin24}>
                  <RadioSelector
                    options={radioOptionsYesNo}
                    onSelectionChange={selectedValue => {
                      setShowErrorsMain(false);
                      setEmploymentFlag(selectedValue);
                    }}
                    initialValue={employmentFlag}
                  />
                </div>
                {errorsMain.employmentFlag && showErrorsMain ? (
                  <ErrorMsg className={"ErrorMsg_error"}
                    type={"error"}
                    description={"Please make a selection."}
                  />
                ) : null}

              </div>
            </div>
          </>
        )}
        {viewMode == "list" && employmentFlag == "yes" && (
          <div className={"row"}>
            <div className={"col-12"}>
              {renderEmploymentHistory()}
              {!errorsMain.employmentFlag && errorsMain.employmentHistory && showErrorsMain ? (
                <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please enter employment details."}
                />
              ) : null}
              <div className={`row ${styles.buttonCont}`}>
                <div className={`col-12`}>
                  <Button secondary onClick={() => { clearForm(); setSaveMode("add"); setViewMode("form") }}>
                    Add Employer
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {viewMode == "form" &&
          renderEmploymentForm()
        }
      </div>
    );
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={`col-12`}>{renderSection()}</div>
      </div>
      {viewMode == "list" && (
        <div className={`row ${styles.buttonCont}`}>
          <div className={`col-12`}>
            <Button
              onClick={() => {
                if (validate(validatorsMain, setErrorsMain)) {
                  setShowErrorsMain(false);
                  storeData();
                  props.history.push(`./disclosures`);
                } else {
                  setShowErrorsMain(true);
                  scrollToError();
                }
              }}>Continue</Button>
            <Button
              secondary
              onClick={() => {
                storeData();
                dispatch(
                  saveApplication("step2", () => {
                    //props.history.push(`../tattooist-form/application-saved`);
                    window.location.href = `${process.env.REACT_APP_BAU_URL}`;
                  })
                );
              }}
            >
              Save & exit section
          </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(props => <Employment {...props} />);
